/**
 * Route names defined for routes leading to multiple versions of application,
 * according to user type.
 *
 * This can be imagined as the root tree node in tree of routes.
 */
export const mainRouteNames = {
  organizerSidebar: 'organizer-sidebar',
  theaterOrganizerSidebar: 'theater-organizer-sidebar',
  sportOrganizerSidebar: 'sport-organizer-sidebar',
  organizationSidebar: 'organization-sidebar',
  theaterOrganizationSidebar: 'organization-theater-sidebar',
  sportOrganizationSidebar: 'organization-sport-sidebar',
  ticketSellerSidebar: 'ticket-seller-sidebar',
}
